import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './RegisterPromptModal.css';

/**
 * Prompt guests to register/log in when they hit a gated action
 * (save, schedule visit) or a guest quota limit.
 */
export default function RegisterPromptModal({ open, onClose, title, message }) {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === 'Escape') handleClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, handleClose]);

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={handleClose} role="dialog" aria-modal="true" aria-labelledby="register-prompt-title">
      <div className="modal-card register-prompt-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 id="register-prompt-title">{title || 'Create a free account'}</h2>
          <button type="button" className="modal-close" onClick={handleClose} aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <p className="register-prompt-message">{message}</p>
        <div className="register-prompt-actions">
          <button type="button" className="modal-submit-btn" onClick={() => navigate('/signup')}>
            Sign up free
          </button>
          <button type="button" className="register-prompt-login-btn" onClick={() => navigate('/login')}>
            Log in
          </button>
        </div>
      </div>
    </div>
  );
}
